<app-feature-details-grid>
  <app-feature-list-container>
    <!-- solar.sensors.temperature.collector -->
    <app-feature-list-item
      *ngIf="solarCollectorTemperature$ | async | ready as feature"
      data-at-solar-sensors-temperature-collector
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.TEMPERATURE_COLLECTOR.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- solar.sensors.temperature.dhw -->
    <app-feature-list-item
      *ngIf="solarDhwTemperature$ | async | ready as feature"
      data-at-solar-sensors-temperature-dhw
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.TEMPERATURE_DHW.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- solar.pumps.circuit -->
    <app-feature-list-item
      *ngIf="solarPumps$ | async | ready as feature"
      data-at-solar-pumps-circuit
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.PUMPS.CIRCUIT.TITLE' | translate"
      [value]="feature.properties?.status?.value | uppercase"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- solar.rechargeSuppression -->
    <app-feature-list-item
      *ngIf="solarRechargeSuppression$ | async | ready as feature"
      data-at-solar-rechargeSuppression
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.RECHARGE_SUPPRESSION.TITLE' | translate"
      [value]="feature.properties?.status?.value | uppercase"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>

    <!-- solar.statistics -->
    <app-feature-list-item
      *ngIf="solarStatistics$ | async | ready as feature"
      data-at-solar-statistics
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.STATISTICS.TITLE' | translate"
      value="{{ feature | value2: featurePropertyKey.hours }} {{ feature | unit: 'hours' }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    >
    </app-feature-list-item>
  </app-feature-list-container>
  <app-feature-list-container *ngIf="solarCumulativeProduced$ | async | ready as solar">
    <!-- solar.power.cumulativeProduced -->
    <app-feature-list-item
      *ngIf="solar"
      data-at-solar-cumulativeProduced
      [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.CUMULATIVE_PRODUCED.TITLE' | translate"
      value="{{ solar | value2: featurePropertyKey.value }} {{ solar | unit: 'value' }}"
      [attr.data-feature]="solar.feature"
      [error]="solar | error"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
